import { render } from "./select-searchable.vue?vue&type=template&id=6f6d969a"
import script from "./select-searchable.vue?vue&type=script&lang=js"
export * from "./select-searchable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__